import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors, FormGroup, AbstractControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ValidatorsService {

  public firstNameAndLastnamePattern: string = '([a-zA-Z]+) ([a-zA-Z]+)';
  public emailPattern: string = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";


  public isValidField(form: FormGroup, field: string) {
    return form.controls[field].errors && form.controls[field].touched;
  }


  // public isFieldOneEqualFieldTwo(field1: string, field2: string) {
  //   return (formGroup: AbstractControl): ValidationErrors | null => {
  //     const fieldValue1 = formGroup.get(field1)?.value;
  //     const fieldValue2 = formGroup.get(field2)?.value;
  //     if (fieldValue1 !== fieldValue2) {
  //       formGroup.get(field2)?.setErrors({ notEqual: true });
  //       return { notEqual: true }
  //     }
  //     formGroup.get(field2)?.setErrors(null);
  //     return null;
  //   }

  // }

  // public getFieldError(form: FormGroup,field: string) {
  //   if (!form.controls[field]) return null;
  //   const errors = form.controls[field].errors || {};

  //   for (const key of Object.keys(errors)) {
  //     switch (key) {
  //       case 'required':
  //         return 'Este campo es requerido';
  //       case 'minlength':
  //         return `Mínimo ${errors['minlength'].requiredLength} caracters.`;
  //     }

  //   }
  // }

  getFieldError(form: FormGroup, field: string): string {
    const control = form?.controls[field];

    if (!control || !control.errors || !control.touched) return '';

    const errors = control.errors;

    const errorMessages: { [key: string]: string } = {
      required: 'Este campo es obligatorio',
      maxlength: `Máximo ${errors.maxlength?.requiredLength} caracteres`,
      minlength: `Mínimo ${errors.minlength?.requiredLength} caracteres`,
      min: `El valor mínimo es ${errors.min?.min}`,
      max: `El valor máximo es ${errors.max?.max}`,
      pattern: 'El formato ingresado no es válido',
    };

    // Buscar el primer error encontrado y devolver su mensaje
    const firstErrorKey = Object.keys(errors)[0];
    return errorMessages[firstErrorKey] || 'Error desconocido';
  }

}
